module.exports = __webpack_public_path__ + "static/media/motorola-moto-z-force-1.53683d34.jpg";